module.exports = __webpack_public_path__ + "img/transportation.77856ed7.png";